import React from 'react';
import { MasterLayout } from 'layout';
import { TongHopKetQua } from 'modules/thong-ke-bao-cao';

class KetQuaKiemTraTheoKeHoachDoanhNghiepPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP' />
      </MasterLayout>
    );
  }
}

export default KetQuaKiemTraTheoKeHoachDoanhNghiepPage;



// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/KetQuaKiemTraTheoKeHoachDoanhNghiep.jsx